<div class="bottom-sheet-overlay" [class.visible]="sheetOpen()" (click)="onOverlayClick()"></div>

<div class="bottom-sheet" [class.open]="sheetOpen()" [style.transform]="sheetStyleTransform">
  <div *ngIf="!isMobile()" class="bottom-sheet__cap" (pointerdown)="onDragStart($event)">
    <img class="bottom-sheet__angle bottom-sheet__angle--left" src="/public/svgs/angle-l.svg" alt="" />
    <img class="bottom-sheet__angle bottom-sheet__angle--right" src="/public/svgs/angle-right.svg" alt="" />
    <div class="bs-cap__chips">
      <a
        *ngFor="let item of capNavItems; trackBy: trackByLabel"
        class="bs-cap__chip"
        [routerLink]="item.route"
        routerLinkActive="bs-cap__chip--active"
        [routerLinkActiveOptions]="{ exact: true }"
        [attr.aria-label]="item.ariaLabel | translate"
        (pointerdown)="$event.stopPropagation()"
      >
        <div class="bs-cap__chip-text">{{ item.label | translate }}</div>
      </a>
    </div>
  </div>
  <div class="bottom-sheet__handle" (pointerdown)="onDragStart($event)">
  </div>
  <div class="bottom-sheet__content">
    <ng-content></ng-content>
  </div>
</div>


